import { useMediaQuery } from '@withjoy/joykit/utils';
import type { TypographyVariant } from '@withjoy/joykit/theme';

// Typography variant for the event-name title banner. Below xs (480) it steps down to display4 —
// at display6 a long name alone makes the banner taller. See `EVENT_TITLE_TYPOGRAPHY_OVERRIDE`.
export const useEventNameTitleVariant = (): TypographyVariant => {
  const isXsScreen = useMediaQuery(theme => theme.mediaQueries.between(0, { breakpointAlias: 'xs' }));

  return isXsScreen ? 'display4' : 'display6';
};
